<script lang="ts" setup>
  import { cn } from "@/lib/utils"
  import {
    StepperDescription,
    useForwardProps,
    type StepperDescriptionProps,
  } from "reka-ui"
  import { computed, type HTMLAttributes } from "vue"

  const props = defineProps<
    StepperDescriptionProps & {
      class?: HTMLAttributes["class"]
      ariaLabel?: string
    }
  >()

  const delegatedProps = computed(() => {
    const { class: _, ariaLabel: __, ...delegated } = props

    return delegated
  })

  const forwarded = useForwardProps(delegatedProps)
</script>

<template>
  <StepperDescription
    v-bind="forwarded"
    :aria-label="ariaLabel"
    :class="cn('text min-h-5 text-sm text-secondary-500', props.class)"
  >
    <slot />
  </StepperDescription>
</template>
